<template>
	<div class="attr-info-body">
		<div class="name-box">
			<div class="input-box">
				<span style="font-size:14px">商品名称：{{goodName}}</span>
				<!-- <el-input
					v-model=""
					class="name-input"
					disabled
					size="mini"
				></el-input> -->
			</div>
		</div>
		<div class="attr-info-container">
			<MainTable ref="mainTable" :editDisable="editDisable"/>
			<AttrInfo ref="attrInfo" :editDisable="editDisable"/>
		</div>
		<div class="attr-info-btn">
			<el-button class="btn" size="small" plain type="primary" @click="cancel">取消</el-button>
			<el-button class="btn" size="small" type="primary" v-show="true" @click="save">保存</el-button>
		</div>
	</div>
</template>

<script>
import MainTable from '@/components/goodsManagement/attributesInfo/MainTable.vue'
import AttrInfo from '@/components/goodsManagement/attributesInfo/AttrInfo.vue'
export default {
	name: 'attributesInfo',
	components: {
		MainTable,
		AttrInfo
	},
	data () {
		return {
			attrInfo: {},
			goodName: '',
			editDisable: true
		}
	},
	created () {
		this.goodName = window.sessionStorage.getItem('goodName')
		this.getAuthority('02_0001_0000_00')
	},
	methods: {
		getAuthority (id) {
			let params = {
				pId: id
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result) {
					console.log(res)
					let a = res.data
					if (a.indexOf('02_0001_0001_00') > -1) {
						this.editDisable = true
					} else {
						if (window.sessionStorage.getItem('goodsAdd') === 'true') {
							this.editDisable = true
						} else {
							this.editDisable = false
						}
					}
				}
			})
		},
		save () {
			if (this.$refs.mainTable.getTableData() < 1) {
				this.$message.error('请先添加单位！')
			} else {
				this.attrInfo = this.$refs.attrInfo.getInfo()
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/goods/updateGoodsEleInfo`,
					data: this.attrInfo
				}).then(res => {
					if (res.result) {
						this.$message.success('保存成功！')
					}
				})
			}
		},
		cancel () {
			this.$refs.attrInfo.resetForm()
		}
	}
}
</script>

<style lang="stylus" scoped>
.attr-info-body {
	height: calc(100% - 75px);
	display: flex;
	flex: 1;
	min-width: 730px;
	flex-direction: column;
	.name-box{
		height :60px;
		line-height :60px;
		text-align :left;
		border-bottom 1px solid #dce2fd
		.input-box{
			margin-left :10px;
			overflow-x :hidden
			margin-bottom:10px
		}
	}
	.attr-info-container {
		display flex
		flex: 1
		flex-direction column
		overflow-y auto
	}
	.attr-info-btn {
		padding: 20px 0
		text-align left
		.btn {
			width :130px;
			height :35px;
			margin-left :20px;
		}
	}
}
</style>
